import { render, staticRenderFns } from "./ListSuveyWebpart.vue?vue&type=template&id=5f5bf866"
import script from "./ListSuveyWebpart.ts?vue&type=script&lang=ts&external"
export * from "./ListSuveyWebpart.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports